import React, { useState } from "react"
import { WARNING_RULES } from "./plannerLabels"

const storageKey = userId => "sportya-events-planner-information:" + userId
const remembered = userId => { try { return localStorage.getItem(storageKey(userId)) === "open" } catch (error) { return false } }
const remember = (userId, open) => { try { localStorage.setItem(storageKey(userId), open ? "open" : "closed") } catch (error) { /* Storage is optional. */ } }

// "Useful information" (story 59): the warning rules with their thresholds and whether each can be acknowledged, and how holidays
// are drawn. Collapsed until opened; each SuperAdmin's choice is remembered.
export default function UsefulInformation({ userId }) {
  const [open, setOpen] = useState(() => remembered(userId))
  const toggle = () => { remember(userId, !open); setOpen(!open) }
  return <section className="ep-card ep-information">
    <button type="button" className="ep-information-toggle" aria-expanded={open} aria-controls="ep-information" onClick={toggle}>
      <i className="bx bx-info-circle" aria-hidden="true" /><b>Useful information</b>
      <span className="ep-meta">Warning rules and thresholds, holidays</span>
      <i className={"bx ep-information-chevron " + (open ? "bx-chevron-up" : "bx-chevron-down")} aria-hidden="true" />
    </button>
    {open && <div id="ep-information" className="ep-information-body">
      <p className="ep-meta">Warnings never block: you decide. They are computed each time the calendar is read, only on proposals that
        are not published yet (Draft, Proposed, Confirmed), against every other tournament of the same country that is not declined,
        withdrawn, cancelled or deleted. A published event never carries a warning, and organizers never see them.</p>
      <div role="table" aria-label="Warning rules" className="ep-rules">
        <div role="row" className="ep-rule ep-rule-head">
          <span role="columnheader">Warning</span><span role="columnheader">When</span><span role="columnheader">Acknowledge</span>
        </div>
        {WARNING_RULES.map(({ rule, label, when, acknowledgement }) => <div role="row" className="ep-rule" key={rule}>
          <span role="rowheader" className="ep-rule-name">{label}</span><span role="cell">{when}</span>
          <span role="cell" className="ep-meta">{acknowledgement}</span>
        </div>)}
      </div>
      <p className="ep-meta">Legal holidays are computed for Romania and Bulgaria; declared days off are added with their source. Only
        Easter, Christmas and New Year give a warning.</p>
    </div>}
  </section>
}
